module.exports = __webpack_public_path__ + "img/undraw_color__schemes_wv48.840931f3.svg";